'use strict';
mpangoApp.controller('MactivitylogController',MactivitylogController);
function MactivitylogController($rootScope, $scope, $state, Mreports, Notification, $filter,$window) {
   $scope.$on('$viewContentLoaded', function () {
        Mreports.getActlog().success(function(data, status) {
            $scope.actlogs = data;
        }).error(function() {
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    });
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
}
MactivitylogController.$inject = ['$rootScope', '$scope','$state', 'Mreports', 'Notification', '$filter','$window'];